import { render } from "./PromoButton.vue?vue&type=template&id=41cdd50e"
import script from "./PromoButton.vue?vue&type=script&lang=js"
export * from "./PromoButton.vue?vue&type=script&lang=js"

import "@/styles/PromoButton.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__